<div class="bg-white shadow-lg rounded-lg overflow-hidden">
  <!-- Header -->
  <div class="bg-gradient-to-r from-blue-600 to-blue-800 px-6 py-6">
    <div class="flex justify-between items-center">
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
          <mat-icon class="text-white">warning</mat-icon>
        </div>
        <div>
          <h1 class="text-xl font-bold text-white">{{ title }}</h1>
        </div>
      </div>
      <button mat-icon-button mat-dialog-close class="text-white hover:bg-white hover:bg-opacity-20">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="p-6">
    <div class="flex items-start space-x-4">
      <div class="flex-shrink-0">
        <div class="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
          <mat-icon class="text-yellow-600">help_outline</mat-icon>
        </div>
      </div>
      <div class="flex-1">
        <p class="text-gray-700 text-base leading-relaxed">{{ message }}</p>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-end space-x-4 px-6 py-4 bg-gray-50 border-t border-gray-200">
    <button 
      mat-button 
      mat-dialog-close
      class="px-6 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
      {{ cancelButton }}
    </button>
    <button 
      mat-button 
      [mat-dialog-close]="true" 
      cdkFocusInitial
      class="px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
      {{ confirmButton }}
    </button>
  </div>
</div>
